// extracted by mini-css-extract-plugin
module.exports = {"Attribute":"_28Mr3LT0","Title":"_24lw_lvh","Label":"HtYZoFol","subTitle":"_2YIQulJi"};
    if(module.hot) {
      // 1754515035132
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  